exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.md-layout-item[data-v-4f9e9253] {\n  height: 40px;\n  padding: 10px;\n}\n.footer[data-v-4f9e9253] {\n  height: 40px;\n  margin-top: 10px;\n  background-color: #1e2b33;\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/elements/footer.vue"],"names":[],"mappings":";AAAA;EACE,aAAa;EACb,cAAc;CAAE;AAElB;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;CAAE","file":"footer.vue","sourcesContent":[".md-layout-item {\n  height: 40px;\n  padding: 10px; }\n\n.footer {\n  height: 40px;\n  margin-top: 10px;\n  background-color: #1e2b33; }\n"],"sourceRoot":""}]);

// exports
